<template>
  <div class="l-container container">
    <div>
      <div class="step">
        <Step :currentStep="2" :steps="steps" />
      </div>
      <div class="title">
        <h1>補助利用申請</h1>
      </div>
    </div>

    <a-divider />
    <div class="box">
      <div class="box-content">
        <div>
          <Item :data="dataItemOrder" />
        </div>
        <div>
          <SectionContentTitle
            :lineType="lineType.vertical"
            :titleContent="titleContent[0]"
          />
          <div class="menu-content1">
            <div class="items-content pb-2">
              <div class="item-content gap-3">
                <p>宿泊期間</p>
                <span class="mr-2" v-if="stayDay">{{ stayDay }}</span>
                <span class="mr-2" v-if="nightCnt">{{ nightCnt }} 泊</span>
                <span class="mr-2" v-if="stayRoom">{{ stayRoom }} 部屋</span>
                <span class="mr-2"
                  >（大人{{ totalAdult | formatInteger }}名/子ども{{
                    totalChild | formatInteger
                  }}名）</span
                >
              </div>
              <!-- <div class="item-content gap-3">
                <p>チェックイン</p>
                <span class="mr-2">{{checkinTime}}:00</span>
              </div> -->
              <div class="item-content gap-3">
                <p>宿泊料金</p>
                <span class="mr-2">宿泊料金合計</span><span class="mr-2">{{ totalFeeInfo.totalFee | formatCurrency }}</span>
              </div>
              <div class="item-content gap-3">
                <p></p>
                <span class="mr-2">うち補助対象料金</span><span class="mr-2">{{ totalFeeInfo.subsidyTargetTotalFee | formatCurrency }}</span>
              </div>
            </div>
          </div>
          <a-divider /> 
          <div class="menu-content2">
            <div class="subsidy-usage" v-if="subsidyUsage">
              <SectionContentTitle
                :lineType="'v-line'"
                :titleContent="'補助利用申請'"
                class="pt-5 text-xl sm:text-sm"
              />
              <!-- Company-subsidize -->
              <div class="auxiliary-coupon">
                <!-- Coupon-B -->
                <!-- Table-detail-7 -->
                <div>
                  <table class="table-common">
                    <tr class="label-inp tr-selected-coupon">
                      <td class="flex style-l">
                        <div class="font-bold label-l">数量</div>
                        <div class="ml-5 category">必須</div>
                      </td>
                      <td class="data">
                        <div class="items-data">
                          <div class="label-data w-full">
                            <div
                              class="sub-items"
                              v-if="couponForceTotal && couponOptionTotal"
                            >
                              <div class="grid">
                                <span> 利用する（自動補助クーポン） </span>
                                <span>
                                  {{
                                    couponOptionTotalPopUp ? '利用する' : '未選択'
                                  }}（選択補助クーポン）
                                </span>
                              </div>
                              <div class="grid price-cal">
                                <span class="font-bold">
                                  {{ couponForceTotal | formatCurrency }}分
                                </span>
                                <span class="font-bold" v-if="couponOptionTotalPopUp">
                                  {{ couponOptionTotalPopUp | formatCurrency }}分
                                </span>
                              </div>
                            </div>
                            <div
                              class="sub-items"
                              v-if="couponForceTotal && !couponOptionTotal"
                            >
                              <div class="grid">
                                <span> 利用する（自動補助クーポン） </span>
                              </div>
                              <div class="grid price-cal">
                                <span class="font-bold">
                                  {{ couponForceTotal | formatCurrency }}分
                                </span>
                              </div>
                            </div>
                            <div
                              class="sub-items"
                              v-if="couponOptionTotal && !couponForceTotal"
                            >
                              <div class="grid">
                                <span>
                                  {{
                                    couponOptionTotalPopUp ? '利用する' : '未選択'
                                  }}（選択補助クーポン）
                                </span>
                              </div>
                              <div class="grid price-cal">
                                <span> </span>
                                <span class="font-bold" v-if="couponOptionTotalPopUp">
                                  {{ couponOptionTotalPopUp | formatCurrency }}分
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="modify-button flex justify-end gap-x-3">
                  <div
                    v-if="subsidyAvailables.length"
                    class="available-coupon-balloon"
                  >
                    <p>利用できる補助クーポンがあります</p>
                  </div>
                  <a-button
                    @click="onClickOpenCoupon()"
                    size="large"
                    class="text-bold sm:text-sm"
                    :disabled="
                      !subsidyAvailables.length || !activeCouponBtn
                    "
                    :class="[
                      !subsidyAvailables.length || !activeCouponBtn
                        ? 'btn-disable'
                        : ''
                    ]"
                    >申請する</a-button
                  >
                </div>
              </div>
              <a-divider />
              <div class="flex justify-end">
                <a-button
                  size="large"
                  class="text-bold sm:text-sm"
                  @click="
                    resetCoupons()
                    "
                  >やり直す</a-button
                >
              </div>
            </div>
          </div>
        </div>
        <SelectedSubsidyList
          :selectedSubsidyList="selectedSubsidyList"
        />
        <a-divider />
        <div class="buttons flex gap-2 justify-center mt-4 mb-4">
          <button @click="$router.go(-1)" class="c-btn btn-white">
            <span class="">戻る</span>
          </button>
          <button class="c-btn btn-black" 
            :class="[isAcceptRequire ? 'btn-grey' : 'disabled-btn']"
            :disabled="!isAcceptRequire"
            @click="handleNext">
          次へ
          </button>
        </div>
      </div>
    </div>
    <UseCouponPopup
      :visible="popupUseCoupon"
      @ok="onApplyCoupon"
      @getTotalCoupon="getTotalCoupon"
      @cancel="popupUseCoupon = false"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { Step, Item, SectionContentTitle } from '@/components/compound'
import { GET_LOCATE, UPDATE_INFO_DETAIL } from '@/store/modules/bs_app/actions'
import locateData from '@/jsons-data/locate.json'
import func_utils from '@/mixins/func_utils'
import moment from 'moment'
import { Core as YubinBangoCore } from '@/utils/yubinbango-core2/yubinbango-core'
import { codes } from '@/constants/prefectures'
import UseCouponPopup from './components/UseCouponPopup'
import { SAVE_CUSTOMER_PLAN } from '@/store/modules/plan/actions'
import SelectedSubsidyList from '../components/SelectedSubsidyList'
import { customPlanToSelectedSubsidyList } from '../utils/dataConverters'
export default {
  mixins: [func_utils],
  components: {
    Step,
    Item,
    SectionContentTitle,
    UseCouponPopup,
    SelectedSubsidyList
  },
  data() {
    return {
      customerPlan: null,
      email: 0,
      phone: 0,
      isEditEmail: false,
      isEditPhone: false,
      myEmail: '',
      myPhone: 0,
      firstEmail: '',
      secondEmail: '',
      firstTel: '',
      secondTel: '',
      zipCode1: '',
      zipCode2: '',
      prefectures: null,
      cityAddress: null,
      apartment_number: '',
      titleContent: ['お申し込み内容', '申込者情報'],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      steps: [
        {
          id: 1,
          label: '申請内容を入力'
        },
        {
          id: 2,
          label: '申請者情報を入力'
        },
        {
          id: 3,
          label: '補助金利用申請'
        },
        {
          id: 4,
          label: '申込内容確認'
        },
        {
          id: 5,
          label: '申込完了'
        }
      ],
      options: [],
      error_message_zipcode: null,
      error_message_prefectures: null,
      error_message_cityAddress: null,
      hasError: false,
      info_person_form: {
        memberId: '',
        firstName: '',
        familyName: '',
        apartment_number: '',
        email: '',
        secondEmail: null,
        tel: '',
        secondTel: null
      },
      locate: locateData.locate,
      dataItemOrder: {},
      checkinTime: '',
      useCoupon: false,
      profileInfo: {},
      totalAdultPeople: 0,
      totalChildren: 0,
      textUnregister: '未登録',
      zipcodeError: false,
      isForeign: false,
      stayDay: null,
      nightCnt: null,
      stayRoom: null,
      totalAdult: null,
      totalChild: null,
      popupUseCoupon: false,
      activeCouponBtn: true,
      subsidyAvailables: [],
      subsidyUsage: false,
      couponForceTotal: null,
      couponOptionTotal: true,
      couponOptionTotalPopUp: null,
      totalFeeInfo: {
        totalFee:0,
        subsidyTargetTotalFee:0
      },
      selectedSubsidyList: [],
    }
  },
  mounted() {
    let orderData = _.get(this.$store.state, 'order.menuBasicInfo.menuNo', null)
    if (orderData === null) {
      this.$router.push("/interrupt")
      return
    }

    // クーポン選択情報の初期化
    this.dev('mounted 02_004_NEW')
    this.subsidyAvailables = this.$store.getters['order/get'].subsidyAvailables;
    this.dump('subsidyAvailables', this.subsidyAvailables)

    const infoPublicStay = this.$store.getters['order/get'].orderPublicStay
    this.stayDay = _.get(infoPublicStay, 'stayDateRoom.date', null)
      ? moment(_.get(infoPublicStay, 'stayDateRoom.date', null)).format(
          'YYYY年MM月DD日から'
        )
      : null
    this.nightCnt = _.get(infoPublicStay, 'stayDateRoom.stayNight', null)
    this.stayRoom = _.get(infoPublicStay, 'stayDateRoom.stayRoom', null)

    this.dataItemOrder = this.$store.getters['order/get'].dataItemPublicStay
    this.useCoupon = this.$store.getters.isUseCoupon
    this.useBenepoPoint = this.$store.getters.isUseBenepoPoint
    this.customerPlan = this.customerPlanState
    // this.getPlanBasicInfo()
    this.mountData()
    this.getProfileInfo()
    this.getTotalPeople()
    this.resetCoupons()
    this.subsidyUsage = this.checkLimApplicableDateFrom();
  },
  computed: {
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.getters, 'planDetail', null))
    },
    customerPlanState() {
      return _.cloneDeep(_.get(this.$store.getters, 'customerPlan', null))
    },
    getInfoDetail() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.info_detail', null))
    },
    getDataBsApp02001() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.bs_app_02_001', null))
    },
    selectedWebRadio() {
      // ご利用案内書の受け取り方法 WEBプリント/郵送かで住所必須有無を制御する。
      return _.get(this.$store.getters, 'bs_app.selected_web_radio', null) === 1
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    getPrefecturesList() {
      const list = []
      const prefecturesList = Object.entries(codes)
      prefecturesList.forEach((item) => {
        list.push({ label: item[1].name, value: item[1].name })
      })
      return list
    },
    isAcceptRequire() {
      if (!this.subsidyUsage) return true;
      return this.selectedSubsidyList.length > 0
    }
  },
  methods: {
    dev(msg){
      //alert(msg)
      //console.log(msg)
    },
    dump(...args){
      console.log(...args)
    },
    setSelectedSubsidyList (couponPlanData) {
      this.selectedSubsidyList = customPlanToSelectedSubsidyList(couponPlanData)
    },
    calcPrice: function(priceList) {
      let price = 0;
      for (let i = 0; i < priceList.length; i++) {
        const item = priceList[i];
        price += item.price;
      }
      return price;
    },
    calcTotalPrice: function(selectedSubsidyList) {
      let totalprice = 0;
      this.dump("selectedSubsidyList", selectedSubsidyList);
      // 部屋分ループ
      for (let i = 0; i < selectedSubsidyList.length; i++) {
        const item = selectedSubsidyList[i];
        // クーポン分ループ
        for (let j = 0; j < item.subsidyList.length; j++) {
          const coupon = item.subsidyList[j];
          const price = this.calcPrice(coupon.priceList);
          totalprice += price
        }
      }
      return totalprice
    },
    getTotalPeople() {
      const infoPublicStay = this.$store.getters['order/get'].orderPublicStay
      const peopleRoom = _.get(infoPublicStay, 'peopleRoom', '')
      this.totalAdult = 0
      this.totalChild = 0
      if (peopleRoom) {
        peopleRoom.forEach((element) => {
          this.totalAdult +=
            _.get(element, 'member.man', 0) +
            _.get(element, 'member.woman', 0) +
            _.get(element, 'visitors.man', 0) +
            _.get(element, 'visitors.woman', 0)
          this.totalChild +=
            _.get(element, 'children.childrenMember10', 0) +
            _.get(element, 'children.childrenMember15', 0) +
            _.get(element, 'children.childrenMember20', 0) +
            _.get(element, 'children.childrenMember30', 0) +
            _.get(element, 'children.childrenMember40', 0) +
            _.get(element, 'children.childrenMember50', 0) +
            _.get(element, 'children.childrenVisitor10', 0) +
            _.get(element, 'children.childrenVisitor15', 0) +
            _.get(element, 'children.childrenVisitor20', 0) +
            _.get(element, 'children.childrenVisitor30', 0) +
            _.get(element, 'children.childrenVisitor40', 0) +
            _.get(element, 'children.childrenVisitor50', 0)
        })
      }
    },
    mountData() {
      const bs_app_02_001 = this.getDataBsApp02001
      if (bs_app_02_001) {
        this.checkinTime = bs_app_02_001.checkinTime
        this.totalFee = bs_app_02_001.totalFee
        this.totalAdultPeople = bs_app_02_001.totalAdultPeople
        this.totalChildren = bs_app_02_001.totalChildren
      }
      // 合計金額情報の算出
      this.totalFeeInfo = this.calcFee()
      const customerInfo = this.getInfoDetail ? this.getInfoDetail : null
      if (customerInfo) {
        this.info_person_form.memberId = _.get(this.userInfo, 'ssoCustomerNo', null)
        this.info_person_form.firstName = customerInfo.firstName
        this.info_person_form.familyName = customerInfo.familyName
        this.info_person_form.apartment_number = customerInfo.apartment_number
        this.info_person_form.email = customerInfo.email
        this.info_person_form.secondEmail = customerInfo.secondEmail
        this.info_person_form.tel = customerInfo.tel
        this.info_person_form.secondTel = customerInfo.secondTel
        this.cityAddress = customerInfo.cityAddress
        this.zipCode1 = customerInfo.zipCode1
        this.zipCode2 = customerInfo.zipCode2
        this.prefectures = customerInfo.prefectures
        this.isForeign = customerInfo.isForeign
      }
      this.checkiIsForeign()
    },
    // 宿泊合計料金の算出
    // {
    //  totalFee:宿泊料金合計
    //  subsidyTargetTotalFee:うち補助対象料金
    // }
    calcFee(){
      const infoPublicStay = this.$store.getters['order/get'].orderPublicStay
      const peopleRoom = _.get(infoPublicStay, 'peopleRoom', '')
      let memberTotalFee = 0
      let visitorTotalFee = 0
      this.dump('calcFee peopleRoom', peopleRoom)
      if (peopleRoom) {
        peopleRoom.forEach((element) => {
          let childrenFee = 0
          let visitorChildrenFee = 0
          let memberFee = +_.get(element, 'member.man', 0 ) * +_.get(element, 'member.manPrice', 0)
          let visitorMemberFee = +_.get(element, 'visitors.man', 0 ) * +_.get(element, 'visitors.visitorManPrice', 0)
          childrenFee += +_.get(element, 'children.childrenMember10', 0) * +_.get(element, 'children.childrenMember10Price', 0)
          childrenFee += +_.get(element, 'children.childrenMember15', 0) * +_.get(element, 'children.childrenMember15Price', 0)
          childrenFee += +_.get(element, 'children.childrenMember20', 0) * +_.get(element, 'children.childrenMember20Price', 0)
          childrenFee += +_.get(element, 'children.childrenMember30', 0) * +_.get(element, 'children.childrenMember30Price', 0)
          childrenFee += +_.get(element, 'children.childrenMember40', 0) * +_.get(element, 'children.childrenMember40Price', 0)
          childrenFee += +_.get(element, 'children.childrenMember50', 0) * +_.get(element, 'children.childrenMember50Price', 0)
          visitorChildrenFee += +_.get(element, 'children.childrenVisitor10', 0) * +_.get(element, 'children.childrenVisitor10Price', 0)
          visitorChildrenFee += +_.get(element, 'children.childrenVisitor15', 0) * +_.get(element, 'children.childrenVisitor15Price', 0)
          visitorChildrenFee += +_.get(element, 'children.childrenVisitor20', 0) * +_.get(element, 'children.childrenVisitor20Price', 0)
          visitorChildrenFee += +_.get(element, 'children.childrenVisitor30', 0) * +_.get(element, 'children.childrenVisitor30Price', 0)
          visitorChildrenFee += +_.get(element, 'children.childrenVisitor40', 0) * +_.get(element, 'children.childrenVisitor40Price', 0)
          visitorChildrenFee += +_.get(element, 'children.childrenVisitor50', 0) * +_.get(element, 'children.childrenVisitor50Price', 0)
          memberTotalFee += memberFee + childrenFee
          visitorTotalFee += visitorMemberFee + visitorChildrenFee
        })
        this.dump("calcFee memberTotalFee", memberTotalFee)
        this.dump("calcFee visitorTotalFee", visitorTotalFee)
        memberTotalFee = memberTotalFee * this.nightCnt
        visitorTotalFee = visitorTotalFee * this.nightCnt
      }
      this.dump('calcFee memberTotalFee * staynights', memberTotalFee)
      this.dump('calcFee visitorTotalFee * staynights', visitorTotalFee)
      return {
        totalFee: memberTotalFee + visitorTotalFee,
        subsidyTargetTotalFee: memberTotalFee
      }
    },
    checkiIsForeign() {
      if (this.zipCode1 && this.zipCode2) {
        if (this.zipCode1 === '000' && this.zipCode2 === '0000') {
          this.isForeign = true
          this.hasError = false
          this.prefectures = ''
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
        }
      }
    },
    getPlanBasicInfo() {
      const planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      const roomBasicInfo = this.getPlanInfo ? this.getPlanInfo.roomBasicInfo : null
      if (planBasicInfo && roomBasicInfo) {
        this.dataItemOrder = {
          type: 'type-small',
          menu_id: _.get(planBasicInfo, 'menuNo', ''),
          label: _.get(this.getPlanInfo, 'menuInformation.categoryInfomation', ''),
          baseImg: _.get(planBasicInfo, 'planImages[0].imageUrl', ''),
          title1: _.get(this.getPlanInfo, 'menuInformation.menuNm', ''),
          title2: _.get(planBasicInfo, 'planNm', '')
        }
      }
    },
    getProfileInfo() {
      const infoPublicStay = this.$store.getters['order/get'].orderPublicStay
      console.log(this.profileInfo)
      if (this.getInfoDetail === null) {
        this.profileInfo = _.get(infoPublicStay, 'profileInfo', null)
        if (this.profileInfo) {
          const postalCode = _.get(this.profileInfo, 'addresses[0].postalCode', '')
          this.info_person_form.memberId = _.get(this.userInfo, 'ssoCustomerNo', null)
          this.info_person_form.firstName = this.profileInfo.firstName
          this.info_person_form.familyName = this.profileInfo.familyName
          this.info_person_form.firstNameKana = this.profileInfo.firstNameKana
          this.info_person_form.familyNameKana = this.profileInfo.familyNameKana
          this.info_person_form.email = this.profileInfo.email
          this.info_person_form.secondEmail = this.profileInfo.secondEmail
          this.info_person_form.tel = this.profileInfo.tel
          this.info_person_form.secondTel = this.profileInfo.secondTel
          this.isForeign = this.profileInfo.isForeign
          if (postalCode) {
            this.cityAddress = _.get(this.profileInfo, 'addresses[0].address1', '')
            this.info_person_form.apartment_number = _.get(
              this.profileInfo,
              'addresses[0].address2',
              ''
            )
            this.zipCode1 = postalCode.substring(0, 3)
            this.zipCode2 = postalCode.substring(3, 7)
            this.getProfileMe()
          }
        }
        this.checkiIsForeign()
      }
    },
    getProfileMe() {
      const zipCode = `${this.zipCode1}${this.zipCode2}`
      if (this.zipCode1 && this.zipCode2) {
        new YubinBangoCore(zipCode, (data) => {
          if (data !== null) {
            this.prefectures = data.region ? data.region : undefined
          }
        })
      }
    },
    checkMessageError() {
      this.hasError = false
      if(this.selectedWebRadio) {
        return;
      }
      if(!this.isForeign) {
        if (this.prefectures === '') {
          this.hasError = true
          this.error_message_prefectures = '都道府県を入力してください'
        } else {
          this.error_message_prefectures = ''
        }
        if (!this.cityAddress || this.cityAddress.trim() === '') {
          this.hasError = true
          this.error_message_cityAddress = '市区町村・番地を入力してください'
        } else {
          this.error_message_cityAddress = ''
        }
      }
      if (!this.zipcodeError) {
        if (this.zipCode1 === '' || this.zipCode2 === '') {
          this.hasError = true
          this.error_message_zipcode = '郵便番号を入力してください'
        } else {
          this.error_message_zipcode = ''
        }
      }
    },
    updateInfoDetail() {
      const info = {
        memberId: this.info_person_form.memberId,
        firstName: _.get(this.info_person_form, 'firstName', ''),
        familyName: _.get(this.info_person_form, 'familyName', ''),
        zipCode1: this.zipCode1,
        zipCode2: this.zipCode2,
        prefectures: this.prefectures,
        cityAddress: this.cityAddress ? this.cityAddress.trim() : this.cityAddress,
        apartment_number: _.get(this.info_person_form, 'apartment_number', ''),
        info_person: this.info_person,
        email: this.info_person_form.email,
        secondEmail: this.info_person_form.secondEmail,
        tel: this.info_person_form.tel,
        secondTel: this.info_person_form.secondTel,
        myEmail: this.myEmail,
        myPhone: this.myPhone,
        isForeign: this.isForeign
      }
      this.dev('updateInfoDetail info before route')
      this.dump('updateInfoDetail info before route', info)
      this.$store.dispatch(UPDATE_INFO_DETAIL, info).then(() => {})
    },
    gotoScreen(code) {
      const dataItemOrder = this.$store.getters['order/get'].dataItemPublicStay
      const menuNo = _.get(dataItemOrder, 'menu_id', '')
      switch (code) {
        case 1:
          this.$router.push({ path: '/', query: {} })
          return
        case 2:
          this.$router.push({
            path: `/public-stay/menus/${menuNo}`
          })
          return
        case 3:
          this.$router.push({
            path: '/public-stay/menus/register-rooms'
          })
      }
    },

    // ----------------------------
    // クーポン関連 ここから TODO:
    // ----------------------------
    onClickOpenCoupon() {
      this.dev('onClickOpenCoupon')
      this.popupUseCoupon = true
    },
    getTotalCoupon($event) {
      this.dev('getTotalCoupon')
      const couponObj = $event
      this.couponForceTotal = _.get(couponObj, 'couponForceTotal', null)
      this.couponOptionTotal = _.get(couponObj, 'couponOptionTotal', null)
      this.couponOptionTotalPopUp = _.get(couponObj, 'couponOptionTotal', null)
      this.dump('couponForceTotal', this.couponForceTotal)
      this.dump('couponOptionTotal', this.couponOptionTotal)
      this.dump('couponOptionTotalPopUp', this.couponOptionTotalPopUp)
    },
    async onApplyCoupon($event) {
      this.dev('onApplyCoupon')
      this.activeCouponBtn = false;
      this.popupUseCoupon = false;
      this.dump('onApplyCoupon customerPlan before', customerPlan)
      const customerPlan = _.cloneDeep(this.customerPlan);
      customerPlan['couponPlanData'] = _.cloneDeep($event);
      this.dump('onApplyCoupon customerPlan after', customerPlan)
      this.setSelectedSubsidyList(customerPlan.couponPlanData);
      await this.$store.dispatch(SAVE_CUSTOMER_PLAN, customerPlan);
    },
    resetCoupons() {
      //調査 bus.$emit('resetCouponScreen');
      this.activeCouponBtn = true;
      this.couponOptionTotalPopUp = null;
      // this.getSubsidyCoupons();
      this.selectedSubsidyList = [];
      // ストアのクーポン情報をクリア
      this.dump('resetCoupons customerPlan before', this.customerPlan)
      if (this.customerPlan !== null 
        && this.customerPlan?.couponPlanData !== undefined){
        const customerPlan = _.cloneDeep(this.customerPlan);
        customerPlan['couponPlanData'] = null;
        this.$store.dispatch(SAVE_CUSTOMER_PLAN, customerPlan);
      }
      this.dump('resetCoupons customerPlan after', this.customerPlan)
    },
    checkLimApplicableDateFrom() {
      let isAvailable = false;
      const infoPublicStay = this.$store.getters['order/get'].orderPublicStay
      const stayDay = (_.get(infoPublicStay, 'stayDateRoom.date', null)
        ? moment(_.get(infoPublicStay, 'stayDateRoom.date', null)) : null);
      const stayNight = _.get(infoPublicStay, 'stayDateRoom.stayNight', 1);
      if (this.subsidyAvailables) {
        const priceList = [];
        this.subsidyAvailables.forEach(row => {
          const data = row?.availableData?.priceList;
          if (data) data.forEach(row => priceList.push(row));
        });
        const checkAvailable = (date) => {
          for(let i = 0; i < priceList.length; i++) {
            if(
              moment(priceList[i].limApplicableDateFrom).isSameOrBefore(date, 'day') &&
              moment(priceList[i].limApplicableDateTo).isSameOrAfter(date, 'day')
            ) {
              return true;
            }
          }
          return false;
        };
        const check = [];
        for(let i = 0; i < stayNight; i++) {
          const date = stayDay.add(i, 'd');
          check.push(checkAvailable(date));
        }
        isAvailable = check.indexOf(false) >= 0 ? false : true;
      }
      return isAvailable;
    },
    // ----------------------------
    // クーポン関連 ここまで
    // ----------------------------
    async handleNext() {
      if (!this.subsidyUsage) {
        this.$toasted.error('利用可能な補助金がないため利用できません');
        return;
      }

      const query = this.$route.query
      await this.checkMessageError()
      // this.updateInfoDetail()
      if (!this.hasError) {
        this.$router.push({ path: '/public-stay/menus/register-confirmation', query })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'styles';
.tr-selected-coupon {
  border: 1px solid #DCDEE0;
}
.available-coupon-balloon {
  font-size: 0.875rem;
  font-weight: bold;
  text-align: center;
  color: #fff;
  background-color: #259bee;
  border-radius: 4px;
  padding: 9px 55px;
  position: relative;
  margin-right: 10px;
  @include mq() {
    max-width: none;
    padding: 10px;
    text-align: center;
    > p {
      margin-bottom: 0;
    }
  }
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 0px;
    height: 0px;
    margin: auto;
    right: -19px;
    border-style: solid;
    border-color: transparent transparent transparent #259bee;
    border-width: 10px 10px 10px 10px;

    @include mq() {
      top: 20px;
    }
  }
}
</style>
